import './debug.sass';
import { useState } from 'react';
import classNames from 'classnames';
import flipBool from '../../utils/flipBool';

type DebugComponent = {
  enabled: boolean;
  state?: string;
  vars?: Record<string, any>;
  children?: React.ReactNode;
  toggleStyle?: any;
};

export default function Debug({ enabled, vars, state, children, toggleStyle }: DebugComponent) {
  const [isShowing, setIsShowing] = useState<boolean>(false);

  const toggle = () => {
    setIsShowing(flipBool);
  };

  return (
    <>
      {enabled && (
        <>
          <div className={classNames('debug', isShowing ? 'debug--shown' : '')}>
            <h5>loc: {window.location.href}</h5>
            <h5>State: {state}</h5>
            <ul>
              {Object.entries(vars ?? ({} as Record<string, any>)).map(([key, val]) => (
                <li key={key}>
                  {key}: <span className={classNames('debug__value', val ? (val === Boolean(val) ? 'debug__value--true' : '') : 'debug__value--false')}>{JSON.stringify(val)}</span>
                </li>
              ))}
            </ul>
            {children}
          </div>
          <button className="debug__toggle" onClick={toggle} style={toggleStyle}>
            {isShowing ? 'Hide Debug' : 'Debug'}
          </button>
        </>
      )}
    </>
  );
}
